var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-power",
    "data-name": "Icon ionic-ios-power",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M17.683,7.728a.767.767,0,0,0-.492-.176.752.752,0,0,0-.575.262.725.725,0,0,0-.179.545.742.742,0,0,0,.267.508,6.269,6.269,0,0,1,2.283,4.814,6.485,6.485,0,0,1-12.967,0A6.257,6.257,0,0,1,8.3,8.868a.737.737,0,0,0,.088-1.054.767.767,0,0,0-1.067-.086A7.732,7.732,0,0,0,4.5,13.677a7.93,7.93,0,0,0,8,7.84,7.93,7.93,0,0,0,8-7.84A7.751,7.751,0,0,0,17.683,7.728Z",
    transform: "translate(0 -1.017)",
    fill: "#ee0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M17.63,14.367A.868.868,0,0,0,18.5,13.5V5.367a.867.867,0,0,0-1.734,0V13.5A.868.868,0,0,0,17.63,14.367Z",
    transform: "translate(-5.093)",
    fill: "#ee0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.89336233614c8bcc70d0e41de5b3e305.svg";
export { ForwardRef as ReactComponent };